import { LineStateStatusType } from "../../enums/index";
function GetLineStateClassLineCore(type) {
  switch (type) {
    case "None":
      return "";
    case "Active":
      return "enabled";
    case "Expired":
      return "suspend";
    case "Extended":
      return "suspend";
    case "Cancelled":
      return "disabled";
    case "SeparateFromPackage":
      return "suspend";
    case "Archived":
      return "suspend";
    case "RejectActivation":
      return "disabled";
    default:
      return "";
  }
}
export default GetLineStateClassLineCore;